import React from "react";
import { useNavigate } from "react-router-dom";

const t = {
  title: "Terms of Service",
  lastUpdated: "Last Updated: January 2025",
  back: "Back",
  section1Title: "License Grant",
  section1Li1: "The license is non-exclusive and non-transferable.",
  section1Li2: "Reverse engineering, copying, or distributing any part of the software without written permission is prohibited.",
  section2Title: "Activation and Devices",
  section2P: "Use of the software is limited to the number of devices specified in the license (Device Binding). The system will verify device identity for security.",
  section2Li1: "Device migration or changes must be requested through the system administrator or customer service staff only.",
  section3Title: "Privacy and Security",
  section3P: "The company will collect necessary data (e.g., Email, Device ID) for the purpose of verifying license rights and preventing copyright infringement. All data will be stored in accordance with security standards and the company's Privacy Policy.",
  section4Title: "Suspension and Termination of Service",
  section4P: "The company reserves the right to temporarily or permanently suspend license usage if contract terms are violated or if service fees are overdue, without prior notice.",
  footerP: "If you have any questions about these terms, please contact our legal department or staff.",
};

export default function Terms() {
  const navigate = useNavigate();

  // Colors
  const navy = "#0E2B55";
  const blue = "#3366CC";
  const lightBlue = "#F0F7FF";
  const grayText = "#475569";
  const border = "#E2E8F0";

  const containerStyle = {
    width: "100%",
    maxWidth: 900,
    margin: "40px auto",
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.04), 0 8px 10px -6px rgba(0, 0, 0, 0.04)",
    overflow: "hidden",
    fontFamily: "'Inter', sans-serif",
    border: `1px solid ${border}`,
  };

  const sectionStyle = { padding: "48px 60px" };
  const h2Style = {
    margin: "32px 0 16px",
    fontSize: 20,
    fontWeight: 700,
    color: navy,
    display: "flex",
    alignItems: "center",
    gap: 12,
  };
  const pStyle = { color: grayText, lineHeight: 1.8, fontSize: 15, margin: "12px 0" };
  const liStyle = { marginBottom: 12, color: grayText, lineHeight: 1.6, fontSize: 15 };


  return (
    <div style={{ background: "#F8FAFC", minHeight: "100vh", padding: "20px" }}>
      <div style={containerStyle}>
        <header
          style={{
            padding: "24px 40px",
            borderBottom: `1px solid ${border}`,
            background: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div style={{ fontWeight: 800, fontSize: 18, color: navy, letterSpacing: "-0.5px" }}>
            SMART <span style={{ color: blue }}>AUDIT</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button
              onClick={() => navigate(-1)}
              style={{
                height: 38,
                padding: "0 20px",
                background: "transparent",
                color: grayText,
                border: `1px solid ${border}`,
                borderRadius: 10,
                fontWeight: 600,
                cursor: "pointer",
                fontSize: 14,
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#F1F5F9";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
              }}
            >
              {t.back}
            </button>
          </div>
        </header>

        <main style={sectionStyle}>
          {/* Title Area */}
          <div style={{ borderLeft: `4px solid ${blue}`, paddingLeft: 24, marginBottom: 40 }}>
            <h1 style={{ margin: 0, fontSize: 32, fontWeight: 800, color: navy, letterSpacing: "-1px" }}>
              {t.title}
            </h1>
            <div style={{ color: blue, fontSize: 14, fontWeight: 600, marginTop: 8 }}>
              {t.lastUpdated}
            </div>
          </div>

          <p style={{ ...pStyle, fontSize: 16, color: "#1E293B" }}>
            Terms and conditions for the use of the <strong>Smart Audit</strong> software (&quot;Service&quot;) under Smart Click Solution Co., Ltd. Please read and understand before using the service.
          </p>

          <hr style={{ border: 0, borderTop: `1px solid ${border}`, margin: "40px 0" }} />

          {/* Section 1 */}
          <h2 style={h2Style}>
            <span style={{ color: blue }}>01.</span> {t.section1Title}
          </h2>
          <div style={{ background: lightBlue, padding: 20, borderRadius: 12, marginBottom: 20 }}>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li style={liStyle}>{t.section1Li1}</li>
              <li style={{ ...liStyle, marginBottom: 0 }}>{t.section1Li2}</li>
            </ul>
          </div>

          {/* Section 2 */}
          <h2 style={h2Style}>
            <span style={{ color: blue }}>02.</span> {t.section2Title}
          </h2>
          <p style={pStyle}>{t.section2P}</p>
          <ul style={{ paddingLeft: 20 }}>
            <li style={liStyle}>{t.section2Li1}</li>
          </ul>

          {/* Section 3 */}
          <h2 style={h2Style}>
            <span style={{ color: blue }}>03.</span> {t.section3Title}
          </h2>
          <p style={pStyle}>{t.section3P}</p>

          {/* Section 4 */}
          <h2 style={h2Style}>
            <span style={{ color: blue }}>04.</span> {t.section4Title}
          </h2>
          <p style={pStyle}>{t.section4P}</p>

          {/* Footer Contact */}
          <div
            style={{
              marginTop: 60,
              padding: 30,
              background: "#F8FAFC",
              borderRadius: 12,
              textAlign: "center",
              border: `1px dashed ${border}`,
            }}
          >
            <p style={{ ...pStyle, margin: 0 }}>{t.footerP}</p>
            <a
              href="mailto:info@smartclick.co.th"
              style={{
                color: blue,
                fontWeight: 700,
                textDecoration: "none",
                fontSize: 18,
                display: "block",
                marginTop: 10,
              }}
            >
              info@smartclick.co.th
            </a>
          </div>
        </main>
      </div>

      <style>{`
        @media (max-width: 640px) {
          main { padding: 32px 24px !important; }
          h1 { font-size: 24px !important; }
          .container { margin: 0 auto !important; border-radius: 0 !important; }
          header { padding: 16px 24px !important; }
        }
      `}</style>
    </div>
  );
}
